<template>
    <div class="campaign-item"
        :class="[{'product-item': mainType == 'product'}, {'privilege-item': mainType == 'privilege'}] "
        @click="clickCampaign(mainType)">
        <div class="img-product"><img :src="campaign.fullImageUrl" class="img-fluid rounded-t-lg"/></div>
        <div class="content-campaign" :class="[{'rounded-b-lg':mainType == 'catalogonline'}]">
            <div class="text-name">
                {{campaign.name}}
            </div>
            <div v-html="getPointText(campaign.pointPerUnit, campaign.pointType)"></div>
        </div>
    </div>
</template>
<script>
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
//helper
import Util from "@/helper/Utility.js";

export default {
    name: 'CampaignItem',
    mixins: [
        LocaleMixin,
    ],
    props: {
        //lbl: Object,
        index: Number,
        campaign: Object,
        mainType: String,
    },
    data: function() {
        return {
           // lblCampaign: this.lbl.campaign
        };
    },
    created: function() {

    },
    mounted: function () {
        //this.lblCampaign = this.lbl.campaign;
    },
    methods: {
        //event
        clickCampaign: function (mainType) {
            var route_name = "";
            switch(mainType) {
                case 'product':
                    route_name = 'productdetail';
                    break;
                case 'privilege':
                    route_name = 'privilegedetail';
                    break;
                case 'catalogonline':
                    route_name = 'marketplacedetail';
                    break;
            }
            this.$router.push({ name: route_name, params: { campaignId: this.campaign.id}})
            // var path = '/reward/' + this.campaign.id;
            // this.$router.push(path);
        },
        //method
        isSoldOut: function () {
            return this.campaign.qty < 1
                ? true
                : false
        },
        //utility
        // getPointText: function (point) {
        //     var text_point = this.locale === 1033 && point > 1
        //                 ? this.lbl.campaign.point + 's'
        //                 : this.lbl.campaign.point;

        //     return `<div class="text-point">${this.lbl.campaign.use_point} <span class="points">${Util.formatNum(point)}</span> ${text_point}</div>`;
        // },

        getPointText: function (point, pointType) {
            var pointTypeTxt = pointType && pointType != 'use'
                            ? this.lbl.campaign.get_point
                            : this.lbl.campaign.use_point;

            var pointUnit = this.locale === 1033 && point > 1
                        ? this.lbl.campaign.point + 's'
                        : this.lbl.campaign.point;

            return `<div class="text-point">${pointTypeTxt} <span class="points">${Util.formatNum(point)}</span> ${pointUnit}</div>`;
        }
    },
}
</script>
<style lang="scss">
@import "@/style/base/common.scss";
@import "@/style/base/base.scss";


.campaign-item {
    width: 100%;
    flex: 0 0 100%;
    border-radius: 8px;
    line-height: 1;
    cursor: pointer;
    @include boxShadow(#ffffff, 0.5px, 229, 229, 229);
    border: 0;

    .img-product {
        position: relative;
        border-radius: 4px 4px 0 0;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 50%;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
        }

        &:before {
            position: relative;
            content: "";
            display: block;
            padding-top: 66.67%;
        }
    }

    .content-campaign {
        padding: 8px;
    }

    .text-name {
        @extend %ellipsis-2;
        font-size: 1.5rem;
        height: 50px;
        color: $a-gray-333333;
    }

    .text-point {
        margin-top: 8px;
        font-size: 1.5rem;
        font-weight: normal;
        color: $a-gray-575757;

        .points {
            color: $green-00987F;
            font-weight: 600;
        }
    }
}


</style>
